module.exports = __webpack_public_path__ + "img/vo-way-3.7b5b7c0f.svg";